import { useState } from 'react';
import Translation from './strings.json';


let language = "English";
let company = "";

function setLangauge (newLanguage: string) {

    language = newLanguage;

}

function setCompany (newCompany: string) {
    company = newCompany;
}

function findString (locale: Object, searchString: string) {

    const keys = Object.keys(locale);
    const values = Object.values(locale);

    // Search for the string in the company specific strings
    if (company != "") {
        let index = keys.indexOf(company + "_" + searchString);
        if (index != null && index != -1) { return values[index]; }
    }

    let index = keys.indexOf(searchString);

    if (index != null) { return values[index]; }

    return "N/A";

}

function translate (string: string) {
    if (language === 'English'){
        return findString(Translation.en, string);
    } else {
        return findString(Translation.es, string);
    }
};

// Initialize Localization
const translator = {
    setCompany,
    setLangauge,
    translate

}

export { translator }